import { createBaseStore } from '@/zustand/create-store';
import { STORAGE_KEYS } from '@/zustand/storage-keys';
import { Auth } from '@/zustand/auth/auth-types';

const initialState: Auth = {
	access_token: '',
	expires_in: 0,
	refresh_token: '',
	refresh_expires_in: 0,
	token_type: '',
	scope: '',
	session_state: '',
	'not-before-policy': 0,
	otherClaims: {},
	user: null,
	avatar: null
};

const customActions = (set: (state: Partial<Auth>) => void) => ({
	login: (authData: Omit<Auth, 'user'>, user: Auth['user']) => {
		set({
			...authData,
			user
		});
	},
	logout: () => {
		set(initialState);
	},
	setAvatar: (user: Auth['user']) => {
		set({
			user
		});
	}
});

export const useAuthStore = createBaseStore<Auth>(STORAGE_KEYS.AUTH_STORAGE, initialState, customActions);
